import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.56066 4.43938C9.13166 4.01039 8.48649 3.88205 7.92597 4.11422C7.36546 4.3464 7 4.89335 7 5.50004V14L7 19.5C7 19.5846 6.99456 19.6782 6.98886 19.7763C6.96088 20.2582 6.92663 20.848 7.5 21C7.76798 21.1216 8.27241 20.7582 8.49388 20.5644L11.728 17.7346L13.3146 21.3046C13.3978 21.4918 13.5539 21.6368 13.7467 21.7059C13.9395 21.7751 14.1522 21.7624 14.3354 21.6708L17.3354 20.1708C17.7059 19.9856 17.8561 19.5351 17.6708 19.1646L16.1622 16.1474L20.5679 15.7469C20.8631 15.7201 21.1148 15.5219 21.2102 15.2412C21.3055 14.9605 21.2265 14.65 21.0087 14.4489L13 7.5L13 7.50002L9.56066 4.43938ZM12 8.5L8.5 5.5V12L8.5 18.5L11.5061 15.9356C11.6854 15.7787 11.9287 15.7163 12.1614 15.7676C12.3941 15.8188 12.5886 15.9776 12.6854 16.1954L14.3666 19.9782L15.9938 19.1646L14.3292 15.8354C14.2183 15.6137 14.2242 15.3516 14.3448 15.135C14.4654 14.9185 14.6852 14.7755 14.9321 14.7531L18.7507 14.4059L12 8.5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgClick = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgClick;
